import React, { FC } from 'react'
import { ComponentTable } from '../../../models/components/table'
import { StyledGlobalContainer, TemplateOne, TemplateTwo } from './style'
import { formDesktopTable, formMobileTable } from './utils/formTable'

type Props = {
  data: ComponentTable
}

const Tables: FC<Props> = ({ data }) => {
  let templates = ['TemplateOne', 'TemplateTwo']
  const tableData = {
    data: data.tableData?.tableData || [],
    topPadding: data.topPadding || 'Small',
    bottomPadding: data.bottomPadding || 'Large',
  }

  let template: any, columns: any
  if (tableData.data.length && tableData.data[0]?.length) {
    const templateType = tableData.data[0][0]?.templateType
    template = templates.includes(templateType) ? tableData.data[0][0].templateType : ''
    columns = tableData.data[0][0].columns
  }

  //* TemplateOne requires at least 2 columns (for mobile layout)
  if (!columns || isNaN(columns) || !template || (template === 'TemplateOne' && columns < 2))
    return null

  const desktopTable = formDesktopTable(tableData.data, columns, template, 'desktop')
  if (!desktopTable) return null

  if (template === 'TemplateOne') {
    const mobileTable = formMobileTable(tableData.data, columns, template, 'mobile')
    if (!mobileTable) return null

    return (
      <TemplateOne data-cy={`Table-${template}`}>
        <StyledGlobalContainer
          $topPadding={tableData.topPadding}
          $bottomPadding={tableData.bottomPadding}>
          {desktopTable}
          {mobileTable}
        </StyledGlobalContainer>
      </TemplateOne>
    )
  } else if (template === 'TemplateTwo') {
    return (
      <TemplateTwo data-cy={`Table-${template}`}>
        <StyledGlobalContainer
          $topPadding={tableData.topPadding}
          $bottomPadding={tableData.bottomPadding}>
          {desktopTable}
        </StyledGlobalContainer>
      </TemplateTwo>
    )
  } else {
    return null
  }
}

export default Tables
